import * as React from 'react';
import { ValidationProps } from 'ui';
import { SelectMultiple } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { CodePickerProps, CodePickerState } from '../../../../codetable/common/code-picker/types';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

interface CodeMultiplePickerProps extends CodePickerProps {
  validation?: ValidationProps;
  valueItems: CodeComplexValue<number>[];
  readOnly?: boolean;
  displaySelectAll: boolean;
  locale: string;
  onChange: (value: CodeComplexValue<number>[]) => void;
}

export class CodeMultiplePicker extends React.PureComponent<CodeMultiplePickerProps, CodePickerState> {

  public readonly state: Readonly<CodePickerState> = { loadedOptions: {} };

  private onLoadOptions = (options: LoadOptions) => {

    const { id, onLoadOptions } = this.props;

    onLoadOptions(id, options);
    this.setState({ loadedOptions: options });
  };

  public render() {

    const { id, label, valueItems, options, fetchingOptions, translation, onChange, validation,
      searchRequired, readOnly, displaySelectAll, locale, extraFooterButton } = this.props;

    return <div className="col-lg-6 col-sm-12">
      <SelectMultiple
        componentId={id}
        className={undefined}
        label={label ? { text: label } : undefined}
        validation={validation}
        valueItems={valueItems || []}
        onChange={onChange}
        searchRequired={searchRequired}
        readOnly={readOnly}
        extraFooterButton={extraFooterButton}
        hideAlphabeticIndex={false}

        options={options}
        fetching={fetchingOptions}
        loadOptions={this.state.loadedOptions}
        onLoadOptions={this.onLoadOptions}
        placeholder={translation && translation.search}

        displaySelectAll={displaySelectAll}
        locale={locale}
      />
    </div>;
  }
}
